import { injectIntl } from 'react-intl';

import { DistrictAreaList } from './DistrictAreaList';

export default injectIntl(DistrictAreaList);
